<script lang="ts">
  import { t } from '$core/i18n';
  import { Icon, type IconName } from '$ui/primitives/Icon';

  export type BottomView =
    | 'session'
    | 'history'
    | 'analytics'
    | 'leaderboard'
    | 'more';

  let {
    active,
    onNavigate
  }: {
    active: string;
    onNavigate: (view: BottomView) => void;
  } = $props();

  const items: Array<{ id: BottomView; icon: IconName; labelKey: string }> = [
    { id: 'session', icon: 'play', labelKey: 'shell.nav.session' },
    { id: 'history', icon: 'history', labelKey: 'shell.nav.history' },
    { id: 'analytics', icon: 'bar-chart-3', labelKey: 'shell.nav.analytics' },
    { id: 'leaderboard', icon: 'trophy', labelKey: 'shell.nav.leaderboard' },
    { id: 'more', icon: 'menu', labelKey: 'shell.mobile.more' }
  ];
</script>

<nav class="bottom-nav" aria-label={t('shell.nav.ariaBottomNav')}>
  {#each items as item (item.id)}
    <button
      type="button"
      class="item"
      data-active={active === item.id || undefined}
      aria-current={active === item.id ? 'page' : undefined}
      onclick={() => onNavigate(item.id)}
    >
      <span class="icon" aria-hidden="true">
        <Icon name={item.icon} size={24} />
      </span>
      <span class="label">{t(item.labelKey as Parameters<typeof t>[0])}</span>
    </button>
  {/each}
</nav>

<style>
  .bottom-nav {
    position: sticky;
    bottom: 0;
    z-index: var(--z-sticky);
    display: flex;
    height: 64px;
    padding-bottom: env(safe-area-inset-bottom);
    background: var(--color-surface);
    border-top: var(--border-width) solid var(--color-border);
  }

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 0;
    background: transparent;
    border: none;
    color: var(--color-text-muted);
    font-family: inherit;
    cursor: pointer;
    transition: color var(--dur-fast) var(--ease-out);
  }

  .item[data-active] {
    color: var(--color-accent);
  }

  .item:focus-visible {
    outline: var(--focus-ring-width) solid var(--color-focus-ring);
    outline-offset: -2px;
  }

  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .label {
    font-size: 0.7rem;
    font-weight: var(--weight-semibold);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    line-height: 1;
  }
</style>